module.exports = __webpack_public_path__ + "static/media/ic_gold_provider.942b3762.svg";